import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-cream" data-id="element-0" data-mp="2wk0bn6p7uxy5">
      <MetaPixel data-id="element-1" data-mp="2wiywor52xrb5" />
      <CountdownBar data-id="element-2" data-mp="2wifgpfyzpczr" />
      <main data-id="element-3" data-mp="2whxcnx635uha">
        <Hero data-id="element-4" data-mp="28ufpyg1ohml6" />
        <StatsBar data-id="element-5" data-mp="28tw6guwdqq51" />
        <Difference data-id="element-6" data-mp="28te0v7ntuzkg" />
        <Recognize data-id="element-7" data-mp="28suw6sn6u7od" />
        <WhatsInside data-id="element-8" data-mp="28sbar1ybx15l" />
        <Bonuses data-id="element-9" data-mp="23vkwmk634fmt" />
        <Offer data-id="element-10" data-mp="23w4fq47h1a2f" />
        <Guarantee data-id="element-11" data-mp="23u9q4cl98ts0" />
        <Testimonials data-id="element-12" data-mp="23v2rey1g2r2r" />
        <Faq data-id="element-13" data-mp="23ti7018ugoim" />
      </main>
      <Footer data-id="element-14" data-mp="3ikh829m9asyz" />
    </div>;
}